/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-computed-key */
import React, { Fragment, useState, useEffect, useRef } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import ProductIcon from "../../../../../assets/images/icon_menus/ProductIcon.json";
import clsx from 'clsx';
import { TextField } from '@mui/material';
import customStyles from "../../../../../assets/styles/customStyles";
import { DetailsView } from './DetailsView';
import { useDispatch, useSelector } from "react-redux";
import { checkCRUDViewPermission } from "../../../../../helpers/utilities";
import { useParams } from "react-router-dom";
import { AESDecrypt } from "../../../../../helpers/Crypto";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import qucikLinksActions from "../../../../Dashboard/redux/actions";
import { QuickLinks } from "../../../../Shared/components/BreadCrumbNew/QuickLinks";
import { CustomModal } from "../../../../Shared/components/DeleteModal";
import { emptyValidation } from "../../../../../helpers/validation";
import { idNamingConversion } from "../../../../../helpers/utilities";


export default function StockOnHandView(props) {
    const { readDetails, readError, editLoader, editDetails, editError } = useSelector(state => state.crudReducer);
    const { roleManagement } = useSelector(state => state.authReducer);

    const { history } = props;
    const classes = customStyles();
    const [showDetails, setShowDetails] = useState(true);
    const dispatch = useDispatch();
    let { productId } = useParams();
    const decryptedId = AESDecrypt(productId);
    const prevReadDetails = usePrevious(readDetails);
    const prevReadError = usePrevious(readError);
    const formRef = useRef('');
    const [priceVisible, setPriceVisible] = useState(false);
    const [costPrice, setCostPrice] = useState('');
    const [errorCostPrice, setErrorCostPrice] = useState('');
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);

    const menus = [
        {
            "name": "Change Cost price",
            "link": "",
            "onClick": () => handleChangeCost(decryptedId)
        },
        {
            "name": "Inventory Transaction",
            "link": `/product/inventory/inventory-transaction/${productId}`,
        },
        {
            "name": "Adjust Stock",
            "link": "",
        }
    ];

    const handleChangeCost = (decryptedId) => {
        setPriceVisible(decryptedId)
    }


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            setCostPrice(''); setPriceVisible(''); setErrorCostPrice('');
            toast(`Product Cost Price has been updated successfully`);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            toast.dismiss();
            toast(`Something went worng`);
        }
    }, [editDetails, editError])



    useEffect(() => {
        if (productId !== undefined && decryptedId === 0) {
            history.push('/product/product/stock-on-hand');
            return true;
        }
        if (roleManagement !== '' && checkCRUDViewPermission('Stock on Hand', 'view', history, 'Product')) {
            loadTask();
        }
    }, [productId, roleManagement]);


    const loadTask = () => {
        if (productId) {
            dispatch({ type: crudActions.READ_DETAILS_START, id: decryptedId, url: "stock-on-hands/summary" });
        }
    }

    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            setShowDetails(false);
            setTimeout(function () {
                dispatch({ type: qucikLinksActions.QUICKLINKS_START, menus: menus, toggle: true, factBox: { availableStock: readDetails?.byProduct?.physicalQtyUnit || 0 }, component: "Stock on Hand" });
            }, 200)
        } else if (prevReadError !== undefined && readError && prevReadError !== readError) {
            if (readError.error.statusCode) {
                toast.error('Product ID is invalid');
                history.push('/product/product/stock-on-hand');
            }
        }
    }, [readDetails, readError]);

    const onParentFunction = () => {
        formRef.current.reSize();
    }

    const handleSubmit = () => {
        let emptyCostPrice = emptyValidation('Cost Price', costPrice);
        if (emptyCostPrice.isValid) {
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                url: "client-products",
                id: priceVisible,
                title: "Client Products",
                details: { costPrice: parseFloat(costPrice) }
            })
        } else {
            setErrorCostPrice(emptyCostPrice.errors)
        }
    }

    return (
        <Fragment>
            <MainHeader
                {...props}
                cls={'newImg'} img={ProductIcon} title={'Product'}
                links={[{ 'label': 'Product', 'link': '/product' }, { 'label': 'Stock on Hand', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, { [classes.scrollBorder]: showDetails })}>
                <div id="containerDiv" className={clsx(classes.stickyContainer, classes.productForm)}>
                    <DetailsView {...props} ref={formRef} clsx={clsx} details={readDetails} showDetails={showDetails} classes={classes} />
                </div>
            </div>
            <CustomModal
                onClose={(v) => { setCostPrice(''); setPriceVisible(''); setErrorCostPrice(''); }}
                yesButton={'OK'}
                noButton={'Cancel'}
                title={'Change Cost Price'}
                visible={priceVisible ? true : false}
                onOpen={() => handleSubmit()}
                loading={editLoader}
                yesId={idNamingConversion('OK', 'stockOnHand', 'Button')}
                noId={idNamingConversion('Cancel', 'stockOnHand', 'Button')}
                text={
                    <TextField autoComplete='one-time-code'
                        label={["Cost Price ", <span key={"Cost Price"} className={classes.colorRedRequired}> *</span>]}
                        fullWidth
                        name="costPrice"
                        type="number"
                        id={idNamingConversion('Cost Price', 'stockOnHand', 'TextField')}
                        error={errorCostPrice && true}
                        helperText={errorCostPrice}
                        variant={'standard'}
                        value={costPrice || ''}
                        onKeyDown={(e) => {
                            if (e.keyCode === 13) {
                                handleSubmit();
                            }
                        }}
                        InputProps={{
                            classes: {
                                input: classes.textFieldColor
                            },
                        }}
                        InputLabelProps={{
                            className: classes.textFieldLableColorCustom
                        }}
                        onChange={(e) => setCostPrice(e.target.value)}
                    />
                }
            />
            <QuickLinks menus={menus} component={"Stock on Hand"} factBox={{ availableStock: readDetails?.byProduct?.physicalQtyUnit || 0 }} onParentFunction={() => onParentFunction()} />

        </Fragment>
    )
}